// extracted by mini-css-extract-plugin
module.exports = {"container":"Suggestion_container__QBaHg","content":"Suggestion_content__QJs6o"};